import Cookies from 'universal-cookie';
import moment from 'moment';
import jwt_decode from "jwt-decode";

export default class LineworxClient {

    static  isLoggedIn() {
      const token = this.getToken();
      
      const isloggedin = !!token;
      
      return isloggedin;
    }

    static getTokenDecoded(){
      const token = this.getToken();
      
      if(token){
        return jwt_decode(token);
      }
    }

    static  canShowCrew(){
      //roleId 3 is project manger, allow them as well as admin, owner and super admin 
      // 0 | super_admin     | Super Admin
      // 1 | owner           | Owner
      // 2 | admin           | Admin
      // 3 | project_manager | Project Manager
      // 4 | foreman         | Foreman
      // 5 | working_foreman | Working Foreman
      // 6 | lineman         | Lineman
      // 7 | apprentice      | Apprentice
      return (this.getTokenDecoded() && this.getTokenDecoded().roleId < 4)
    }

    static getUser() {
        return sessionStorage.getItem('user');
    };

    static async login(email, password) {
      
      const requestBody = { email, password };
      const response = await fetch('/api/v1/crew/login',
      {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers:{
          'Content-Type': 'application/json'
        }
      });

      const body = await response.json();

      return { response, body };  
    }

    static async signUp(name, email, password) {

      
      const requestBody = { name, email, password };
      const response = await fetch('/api/v1/crew/sign-up',
      {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers:{
          'Content-Type': 'application/json'
        }
      });

      const body = await response.json();

      return { response, body };  
    }

    static async forgotPassword(email) {
      
        
      const requestBody = { email };
      const response = await fetch('/api/v1/crew/forgot-password',
      {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers:{
          'Content-Type': 'application/json'
        }
      });

      const body = await response.json();

      return { response, body };  
    }


    static async resetPassword(userId, resetToken, password) {
      
        const requestBody = { resetToken, userId,  password };
      const response = await fetch('/api/v1/crew/reset-password',
      {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers:{
          'Content-Type': 'application/json'
        }
      });

      const body = await response.json();

      return { response, body };  
    }


    static async standardFetch(url) {
      const headers = this.getHeaders();
      const response = await fetch(url, { headers });

      var body;
      if (response.ok) {
        body = await response.json();
      }
      
      return { response, body };
    }


    static async saveJob(job) {
        
      const headers = this.getHeaders();

    //   if (token) {
    //     headers['Authorization'] = 'Bearer ' + token
    //   }
    if(job.selectedUtility) {   
        console.log(job.selectedUtility.value);
        job.selected_utility_id = job.selectedUtility.value;
    }

    if(job.selectedForeman) {
        console.log(job.selectedForeman.value);
        job.selected_foreman_id = job.selectedForeman.value;
    }
    // console.log(JSON.stringify(job));
      const requestBody = { job };
      const response = await fetch('/api/v1/jobs/',
      {
        method: 'PUT',
        body: JSON.stringify(requestBody),
        headers
      });

      const body = await response.json();

      return { response, body };  
    }

    static async savePole(pole) {
        
        const headers = this.getHeaders();
  
        const requestBody = { pole };
        const response = await fetch('/api/v1/poles/',
        {
          method: 'PUT',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
      }


    static async addPole(pole) {
        
        const headers = this.getHeaders();
  
      //   if (token) {
      //     headers['Authorization'] = 'Bearer ' + token
      //   }
        const requestBody = { pole };
        const response = await fetch('/api/v1/poles/',
        {
          method: 'POST',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
      }

      static async addPoleByPoleLineUtil(pole_name, line_name, utility, pole_id = null, line_id = null, due_date = null) {
        
        const headers = this.getHeaders();
  
      //   if (token) {
      //     headers['Authorization'] = 'Bearer ' + token
      //   }
        const requestBody = { pole_name, line_name, utility, pole_id, line_id, due_date };
        console.log(requestBody);
        const response = await fetch('/api/v1/poles/',
        {
          method: 'POST',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
      }

      static async doesPoleNeedMerge(ticket) {
        return this.standardFetch("/api/v1/tickets/needsMerge/" + ticket.job_id + "?pole_id=" + ticket.pole.id);
      }


    static async mergeTickets(ticket_id, secondary_ticket) {
        
        const headers = this.getHeaders();
        const requestBody = { secondary_ticket};
        const response = await fetch('/api/v1/tickets/merge/' + ticket_id,
        {
          method: 'PUT',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
      }

    static async saveTicket(ticket) {
        
        const headers = this.getHeaders();
  
      //   if (token) {
      //     headers['Authorization'] = 'Bearer ' + token
      //   }
        const requestBody = { ticket};
        const response = await fetch('/api/v1/tickets/',
        {
          method: 'PUT',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
      }

    static async updateCrew(crew){
      const headers = this.getHeaders();
  
        const requestBody = { crew };
        const response = await fetch('/api/v1/crew/' + crew.id,
        {
          method: 'PUT',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
    }

    static async addCrew(crew){
      const headers = this.getHeaders();
  
        const requestBody = { crew };
        const response = await fetch('/api/v1/crew',
        {
          method: 'POST',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
    }

    // static async getProfile() {
    //   return this.standardFetch("/api/v1/crew/me");
    // }

    static async getCrewByJobForeman(job_id) {
      return this.standardFetch('/api/v1/crew/foreman-crew?job_id=' + job_id);
    }

    static async getTickets(job_id) {
      return this.standardFetch("/api/v1/jobs/tickets/" + job_id);
    }

    static async getTicket(ticket_id) {
        return this.standardFetch("/api/v1/tickets/" + ticket_id);
      }

    static async getJobs() {
      return this.standardFetch("/api/v1/jobs");
    }

    static async getJobById(jid) {
      return this.standardFetch("/api/v1/jobs/" + jid);
    }
      

    static async deleteJobById(jid) {
      return this.standardFetch("/api/v1/jobs/delete/" + jid);
    }

    static async getUtilities() {
      return this.standardFetch("/api/v1/utilities");
    }

    static async getForemen() {
      return this.standardFetch("/api/v1/crew/foremen");
    }

    static async getAllCrew() {
      return this.standardFetch("/api/v1/crew/allCrew");
    }

    static async getConfigurableRoles() {
      return this.standardFetch("/api/v1/crew/configurableRoles");
    }


    static async getMyUserData() {
        return this.standardFetch("/api/v1/crew/myData");
      }

    static async getWorkingForemen() {
      return this.standardFetch("/api/v1/crew/working_foremen");
    }

    static async getSpecsByPartial(partial) {
      return this.standardFetch("/api/v1/specs/partial?partial=" + encodeURIComponent(partial));
    }

    static async checkExistingJobNumber(job_number) {
      return this.standardFetch('/api/v1/jobs/job_exists/' + encodeURIComponent(job_number));
    }

    static async getPolesOrLine(pole, line, porlType) {
      
      let poleStr = pole === undefined ? '' : pole;
      let lineStr = line === undefined ? '' : line;
      
      return this.standardFetch("/api/v1/poles/polesByPoleOrLine?pole=" + encodeURIComponent(poleStr) + "&line=" + encodeURIComponent(lineStr) + "&porlType=" + encodeURIComponent(porlType));
    }

      static async getExactPole(pole, line) {
        return this.standardFetch("/api/v1/poles/specificPole?pole=" + encodeURIComponent(pole) + "&line=" + encodeURIComponent(line));
      }

      static async getExactPoleWUtility(pole, line, utility) {
        return this.standardFetch("/api/v1/poles/specificPole?utility=" + encodeURIComponent(utility) +"&pole=" + encodeURIComponent(pole) + "&line=" + encodeURIComponent(line));
      }

      static async getAccessTypes() {
        return this.standardFetch("/api/v1/poles/accessTypes");
      }

    static async getUploadUrl(where) {
        return this.standardFetch(`/api/v1/doc_upload/sign-s3-pdf?directory=${where}`);
      }

      static async getPolesByUtility(utility, pole, line) {
        return this.standardFetch(`/api/v1/poles/byUtility?utility=${utility}&pole=${pole}&line=${line}`);
      }

      static async getExcelColumns(file_url) {
        return this.standardFetch(`/api/v1/jobs/excel/getColumns?url=` + file_url);
      }

      

    static async uploadXLSX(file) {
      const headers = {};
        // const headers = {
        //   'Content-Type': 'multipart/form-data'
        // }
        const data = new FormData();
        data.append('file', file[0]);
        console.log(file[0])
        const response = await fetch('/api/v1/tickets/xls-upload',
        {
          method: 'POST',
          body: data,
          headers
        });
      
        return response;
      }
    
    
      static async saveUserDetails(user) {
        
        const headers = this.getHeaders();
  
        const requestBody = { user };
        const response = await fetch('/api/v1/crew/myProfileData',
        {
          method: 'PUT',
          body: JSON.stringify(requestBody),
          headers
        });
  
        const body = await response.json();
  
        return { response, body };  
      }


      
      static async getPermitTypes() {
        return this.standardFetch("/api/v1/permits/types");
      }

      // static async getServiceTasks() {
      //   return this.standardFetch("/api/v1/service_tasks");
      // }

      // static async getServiceTasksCategories() {
      //   return this.standardFetch("/api/v1/service_tasks/categories");
      // }

      // static async saveTask(task) {
      //   const headers = this.getHeaders();
      //   const requestBody = { task };
      //   const response = await fetch('/api/v1/service_tasks',
      //   {
      //     method: 'PUT',
      //     body: JSON.stringify(requestBody),
      //     headers
      //   });

      //   const body = await response.json();

      //   return { response, body };  
      // }

    static async getSignedRequest() {
        if (!this.isLoggedIn()) {
            throw new Error('Not logged in');
        }

        const headers = this.getHeaders();
        console.log('Auth headers:', headers); // Debug log

        const response = await fetch('/api/v1/media_upload/sign-s3-media?isVideo=false', {
            method: 'GET',
            headers,
            credentials: 'include'
        });
        
        console.log('Response status:', response.status); // Debug log
        
        if (!response.ok) {
            const text = await response.text();
            console.log('Error response:', text); // Debug log
            throw new Error(`Failed to get signed URL: ${response.statusText}`);
        }
        
        const body = await response.json();
        console.log('Response body:', body); // Debug log
        
        if (!body || !body[0] || !body[0].signedRequest) {
            throw new Error('Invalid response from server');
        }
        
        return {
            signedRequest: body[0].signedRequest,
            url: body[0].url
        };
    }

    static async uploadFileToS3(signedRequest, file) {
        try {
            const response = await fetch(signedRequest, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type,
                    'x-amz-acl': 'public-read'
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to upload file: ${response.statusText}`);
            }

            return response;
        } catch (error) {
            console.error('Error uploading file to S3:', error);
            throw error; 
        }
    }

    static getHeaders() {
      const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      }

      if (this.isLoggedIn()) {
          headers['Authorization'] = 'Bearer ' + this.getToken()
      }

      return headers;
    }



    static getToken() {
      const cookies = new Cookies();
      return cookies.get("lineworx_token");
    }

    static setToken(token) {
      const cookies = new Cookies();
      const options = this.getCookieOptions(window.location.hostname);
      console.log("Set token");
      console.log(options);
      cookies.set("lineworx_token", token, options);
    }

    static logout() {
      const cookies = new Cookies();
      const options = this.getCookieOptions(window.location.hostname);
      console.log("Remove token");
      console.log(options);
      cookies.remove("lineworx_token"); //, options
    }

    static getCookieOptions(domain) {
      
      //if (domain !== "127.0.0.1" && domain !== "localhost") {

        // Assumes that the suffix doesn't have a dot in it. In other words, assuming it's not "co.uk" or something 
        // like it. If we need to support that case then we could get a list of public suffixes.

        const lastDotIndex = domain.lastIndexOf('.');
        const secondToLastDotIndex = domain.lastIndexOf('.', lastDotIndex-1);

        const base = domain.slice(secondToLastDotIndex+1);
        domain = "." + base;
      //}
      const options = domain ? { path: '/', domain } : { path: '/' };

      options.sameSite = "strict";

      return options;
    }

    static async uploadTicketImage(formData) {
        const headers = this.getHeaders();
        // Remove Content-Type header as it will be set automatically with the boundary for FormData
        delete headers['Content-Type'];
        
        const response = await fetch('/api/v1/media_upload/s3-upload-complete', {
            method: 'POST',
            headers,
            body: formData,
            credentials: 'include'
        });

        if (!response.ok) {
            const text = await response.text();
            console.log('Error response from uploadTicketImage:', text);
            throw new Error(`Failed to complete upload: ${response.statusText}`);
        }

        try {
            const body = await response.json();
            return {
                ok: true,
                body
            };
        } catch (error) {
            console.error('Error parsing response:', error);
            throw new Error('Invalid response from server');
        }
    }

    static async deleteTicketImage(imageId) {
        const response = await fetch(`/api/v1/tickets/images/${imageId}`, {
            method: 'DELETE',
            credentials: 'include'
        });
        return {
            ok: response.ok,
            body: await response.json()
        };
    }

}

